import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormCheckboxField = ({
  name,
  label,
  labelClassName = "",
  wrapperClassName = "",
}) => {
  return (
    <Field name={name} type="checkbox">
      {({ field, meta }) => (
        <div className={`flex gap-2 items-center ${wrapperClassName}`}>
          <input type="checkbox" id={name} {...field} />
          <label
            htmlFor={name}
            className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
              meta.touched && meta.error ? "text-errorColor" : labelClassName
            }`}
          >
            {formatUnderscoreToSpace(label)}
          </label>
          {meta.touched && meta.error && (
            <div className="text-errorColor text-sm ps-2">
              <ErrorMessage name={name} />
            </div>
          )}
        </div>
      )}
    </Field>
  );
};

export const FormCheckboxGroupField = ({
  name = "",
  label = "",
  options = [],
  labelClassName = "",
  wrapperClassName = "",
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => (
        <div className={`${wrapperClassName}`}>
          {label && (
            <label
              className={`block mb-1 text-fs_14 md:text-fs_16 font-fw_400 ${
                meta.touched && meta.error ? "text-errorColor" : labelClassName
              }`}
            >
              {label}
            </label>
          )}
          <div className="flex flex-wrap gap-4">
            {options.map((option) => {
              const isChecked = field.value.includes(option.value);
              return (
                <label
                  key={option.value}
                  className="flex items-center gap-2 text-sm"
                >
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                      const nextValue = [...field.value];
                      if (e.target.checked) {
                        nextValue.push(option.value);
                      } else {
                        const idx = nextValue.indexOf(option.value);
                        if (idx > -1) nextValue.splice(idx, 1);
                      }
                      form.setFieldValue(name, nextValue);
                    }}
                  />
                  {option.label}
                </label>
              );
            })}
          </div>
          <div className="text-errorColor text-sm ps-1 h-[1rem]">
            <ErrorMessage name={name} />
          </div>
        </div>
      )}
    </Field>
  );
};

export const FormToggleSwitch = ({
  name,
  label,
  value = false,
  labelClassName = "",
  wrapperClassName = "",
}) => {
  return (
    <Field name={name} type="checkbox">
      {({ field, form, meta }) => (
        <div
          className={`flex items-center leading-none overflow-hidden ${wrapperClassName} my-4`}
        >
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              id={name}
              name={field.name}
              onChange={(e) => form.setFieldValue(name, e.target.checked)}
              onBlur={field.onBlur}
              checked={Boolean(field.value)}
              className="absolute opacity-0 w-0 h-0 peer"
            />
            <div
              className="relative w-11 h-6 bg-white rounded-full dark:bg-greyText 
                peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full 
                peer-checked:after:border-white 
                after:content-[''] after:absolute after:top-[2px] after:start-[2px] 
                after:bg-white after:border-greyText after:border 
                after:rounded-full after:h-5 after:w-5 after:transition-all 
                dark:border-greyText peer-checked:bg-primary"
            />
            {label && (
              <span
                className={`ms-3 text-sm font-medium text-black capitalize ${labelClassName}`}
              >
                {formatUnderscoreToSpace(label)}
              </span>
            )}
          </label>
          {meta.touched && meta.error && (
            <div className="text-errorColor text-sm ps-2">
              <ErrorMessage name={name} />
            </div>
          )}
        </div>
      )}
    </Field>
  );
};

export const ToggleSwitch = ({
  label,
  value = false,
  onChange,
  labelClassName = "",
  wrapperClassName = "",
  disable = false,
}) => {
  return (
    <div
      className={`flex items-center leading-none overflow-hidden ${wrapperClassName} my-4 ${disable === true ? "pointer-events-none opacity-45" : ""}`}
    >
      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          className="absolute opacity-0 w-0 h-0 peer"
        />
        <div
          className="relative w-11 h-6 bg-white rounded-full dark:bg-greyText 
                peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full 
                peer-checked:after:border-white 
                after:content-[''] after:absolute after:top-[2px] after:start-[2px] 
                after:bg-white after:border-greyText after:border 
                after:rounded-full after:h-5 after:w-5 after:transition-all 
                dark:border-greyText peer-checked:bg-primary"
        />
        {label && (
          <span
            className={`ms-3 text-sm font-medium text-black capitalize ${labelClassName}`}
          >
            {formatUnderscoreToSpace(label)}
          </span>
        )}
      </label>
    </div>
  );
};
